import { DataWithPagination } from '@/core/types'
import {
  createCatalogEndpoint,
  createCrudEndpoints,
  createExportEndpoint,
} from '@/core/utils'
import { TAdvisor, TAdvisorType, TCatalogs, TProjectCatalogs } from '.'

export type TAdvisors = DataWithPagination<TAdvisor>

export type TAdvisorTypes = TAdvisorType[]

export const serviceConfig = {
  model: 'advisors',
  version: 'v1',
  projects: {
    model: 'projects',
    version: 'v1',
  },
}

const { projects } = serviceConfig

const moduleServiceHandlers = createCrudEndpoints<TAdvisors, TAdvisor>(
  serviceConfig.model,
  serviceConfig.version,
)
const moduleExportHandler = createExportEndpoint(serviceConfig.model)

const categoriesCatalog = createCatalogEndpoint<TCatalogs>(
  '',
  serviceConfig.version,
)

const projectsCatalogHandler = createCatalogEndpoint<TProjectCatalogs>(
  projects.model,
  serviceConfig.version,
)

export {
  categoriesCatalog,
  moduleExportHandler,
  moduleServiceHandlers,
  projectsCatalogHandler,
}
